import styled from 'styled-components';

const StyledMain = styled.main`
  width: 100%;
  padding-inline: 9.375%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap-reverse;
  gap: 100px;
`;

export default StyledMain;
